import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const GlobalConfirmationModal = ({
    show,
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    confirmColor = 'primary',
    onConfirm,
    onCancel
}) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header>
                <Modal.Title>{title}<br/><br/></Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {cancelLabel}
                </Button>
                <Button variant={confirmColor} onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default GlobalConfirmationModal;
